import app from 'flarum/app';
import lazysizes from "lazysizes";
import {extend} from 'flarum/extend';
import Component from 'flarum/Component';
import Page from 'flarum/components/Page';

import redisFailedAlert from './redisFailedAlert';

app.initializers.add('reflar-recache', () => {
  extend(Component.prototype, 'oncreate', function () {
    $('img, iframe, source').each(function () {
      if ($(this).attr('data-src')) return;
      const src = $(this).attr('src');
      $(this).addClass('lazyload').removeAttr('src').attr('data-src', src);
    });
  });

  extend(Page.prototype, 'onbeforeupdate', function () {
    setTimeout(function() {
      if ($(".LoadingIndicator")[0] && $(".Pages-page")[0]) {
        m.redraw();
      }
    }, 500);
  });

  redisFailedAlert();
});
